export const parseDriversOptions = data => {
  return data?.map(item => ({ value: item?.crn, label: `${item?.firstName || ''} ${item?.lastName || ''}` })) || [];
};
